export default "__VITE_ASSET__Cpspi5m0__"